import { getAuthData, getAuthUserId } from "../auth/session.js";

export async function flightRequest(operation, body = {}, { signal } = {}) {
  const initData = getAuthData();
  if (!initData) throw new Error("Войдите в аккаунт, чтобы участвовать в турнире");
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) controller.abort();
  const timeout = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`/api/minigames/night-flight/${operation}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, initData }), signal: controller.signal,
    });
    let payload;
    try { payload = await response.json(); }
    catch {
      const error = new Error("Восстанавливаем связь…");
      error.status = response.status;
      error.retryable = response.ok || response.status === 429 || response.status >= 500;
      throw error;
    }
    if (!response.ok) {
      const error = new Error(payload.error || "Не удалось выполнить действие");
      error.code = payload.code;
      error.status = response.status;
      if (typeof payload.retryable === "boolean") error.retryable = payload.retryable;
      throw error;
    }
    return payload;
  } catch (error) {
    if (signal?.aborted) throw signal.reason;
    if (error.name === "AbortError" || error instanceof TypeError) {
      const unavailable = new Error("Восстанавливаем связь…");
      unavailable.retryable = true;
      throw unavailable;
    }
    throw error;
  } finally { clearTimeout(timeout); signal?.removeEventListener("abort", abort); }
}

export const pendingKey = () => `metacard-night-flight-pending:${getAuthUserId()}`;
export function savePending(value) {
  try { localStorage.setItem(pendingKey(), JSON.stringify(value)); } catch { /* Retry remains available in this visit. */ }
}
export function readPending() {
  try {
    const saved = JSON.parse(localStorage.getItem(pendingKey()) || "null");
    if (saved && ["start", "checkpoint", "finish", "pause", "resume", "abandon"].includes(saved.operation) && typeof saved.body?.requestId === "string") return saved;
  } catch { /* Invalid or unavailable storage is not an authenticated result. */ }
  return null;
}
export function clearPending(requestId) {
  try { if (readPending()?.body.requestId === requestId) localStorage.removeItem(pendingKey()); } catch { /* Storage may be disabled. */ }
}
